<template>
    <!-- ⚠ **sticky 在這個外層而不是各自的 v-alert 上**：兩個 sticky 兄弟給同樣的 `top`
         會疊在一起（後者蓋住前者），因為 sticky 是各自相對 viewport 計算的。
         包一層之後只有這個 wrapper 黏住，兩張橫幅在裡面正常垂直排列。
         ⚠ `top` 用 `$vuetify.application.top` 動態算，才不會蓋到 app bar。
         ⚠ 兩張都不顯示時這裡是個空 div（高度 0），不會占位。 -->
    <div class="banner-stack" :style="{ top: $vuetify.application.top + 'px' }">
        <SafetyAlertBanner />
        <BlockedQuestBanner />
    </div>
</template>

<script>
import SafetyAlertBanner from '@/components/console/SafetyAlertBanner.vue';
import BlockedQuestBanner from '@/components/console/BlockedQuestBanner.vue';

/**
 * 全站橫幅的堆疊。順序 = 優先順序，上面的比較急。
 *
 * 1. `SafetyAlertBanner` — 學生寫了危險字眼（橘／紅，高風險還會彈對話框）
 * 2. `BlockedQuestBanner` — 有題目因為素材被下架而學生看不到（indigo）
 *
 * ⚠ 新增橫幅請加在這裡，**不要**在 layout 裡再放一個 sticky 兄弟——見 template 的說明。
 * ⚠ 兩個 layout（`ConsoleLayout` / `ConsoleMainLayout`）都用這個元件，
 * 所以只會有一份 sticky 設定；在 layout 各寫一份遲早只改到一邊。
 */
export default {
    name: 'BannerStack',
    components: { SafetyAlertBanner, BlockedQuestBanner },
};
</script>

<style scoped>
.banner-stack {
    position: sticky;
    /* 4 = 原本 .safety-alert-banner 用的值，剛好在頁面內容之上、app bar 之下 */
    z-index: 4;
}
</style>
